

export default {
  components: {},
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {}
};